var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompaniesUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M26.3281 14.8438C26.3281 14.2915 25.8804 13.8437 25.3281 13.8438L16.3281 13.8437C15.7758 13.8437 15.3281 14.2915 15.3281 14.8438C15.3281 15.396 15.7758 15.8438 16.3281 15.8438L24.3281 15.8437L24.3281 23.8437C24.3281 24.396 24.7758 24.8437 25.3281 24.8437C25.8804 24.8437 26.3281 24.396 26.3281 23.8437L26.3281 14.8438ZM13.3073 25.4504C12.9168 25.8409 12.9168 26.474 13.3073 26.8646C13.6978 27.2551 14.331 27.2551 14.7215 26.8646L13.3073 25.4504ZM24.621 14.1366L13.3073 25.4504L14.7215 26.8646L26.0352 15.5509L24.621 14.1366Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompaniesUrl);
export default __webpack_public_path__ + "static/media/companiesUrl.526b7958fd22e8f27d93333cee16de50.svg";
export { ForwardRef as ReactComponent };